// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../../assets/styles/global-colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-modules-common-components-Icons-styles-css-___action-icons__actionIconsWrapper___fhsnW {
  font-size: 12px;
  text-align: right;
}

.client-modules-common-components-Icons-styles-css-___action-icons__iconBlockWrapper___hm9AR {
  display: inline-block;
  text-align: center;
  padding: 0;
}

.client-modules-common-components-Icons-styles-css-___action-icons__iconBlock___nB5OC {
  display: inline-block;
  padding-right: 10px;
  padding-top: 15px;
  padding-left: 10px;
  text-align: center;
}

.client-modules-common-components-Icons-styles-css-___action-icons__revokeIconWrapper___voWP_ {
  display: inline-block;
  padding: 0px;
  text-align: center;
  top: -10px;
}

.client-modules-common-components-Icons-styles-css-___action-icons__revokeIcon___W1fIN {
  margin-top: 5px;
  font-size: 20px !important;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["red"]};
  position: relative;
}

.client-modules-common-components-Icons-styles-css-___action-icons__iconLabel___cgbzl {
  height: 20px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["black"]};
  font-family: Roboto;
  font-size: 13px;
  line-height: 20px;
  text-align: center;
  vertical-align: top;
}

.client-modules-common-components-Icons-styles-css-___action-icons__saveIcon___VlsjC {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["green"]};
  font-size: 30px !important;
  cursor: pointer;
}

.client-modules-common-components-Icons-styles-css-___action-icons__infoIcon___fkDzf {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["grey"]};
  font-size: 30px !important;
  cursor: pointer;
}

.client-modules-common-components-Icons-styles-css-___action-icons__approveIcon___WzMrZ {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue"]};
  font-size: 30px !important;
  cursor: pointer;
}

.client-modules-common-components-Icons-styles-css-___action-icons__restoreIcon___R7NTM {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue"]};
  font-size: 30px !important;
  cursor: pointer;
}

.client-modules-common-components-Icons-styles-css-___action-icons__editIcon___CTZXC {
  color: orange;
  font-size: 30px !important;
  cursor: pointer;
}

.client-modules-common-components-Icons-styles-css-___action-icons__deleteIcon___ox9RD {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["red"]};
  margin-top: 5px;
  font-size: 20px !important;
  position: relative;
  cursor: pointer;
}

.client-modules-common-components-Icons-styles-css-___action-icons__rejectIcon___wSXpi {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["red"]};
  font-size: 30px !important;
  cursor: pointer;
}

.client-modules-common-components-Icons-styles-css-___action-icons__mergeIcon___l6vV7 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["black"]};
  font-size: 35px !important;
  cursor: pointer;
  transform: rotate(90deg);
}

.client-modules-common-components-Icons-styles-css-___action-icons__downloadAsCSVIcon___Y6BQd {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["grey"]};
  font-size: 30px !important;
  cursor: pointer;
}

.client-modules-common-components-Icons-styles-css-___action-icons__duplicateIcon___u2r3U {
  font-size: 30px !important;
  cursor: pointer;
}

.client-modules-common-components-Icons-styles-css-___action-icons__center___uYtoF {
  text-align: center;
}

.client-modules-common-components-Icons-styles-css-___action-icons__disabled___lwM3t {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["grey"]};
}
`, "",{"version":3,"sources":["webpack://./client/modules/common/components/Icons/styles/css/action-icons.css"],"names":[],"mappings":"AAOA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,mDAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mDAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mDAAY;EACZ,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mDAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mDAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mDAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mDAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mDAAU;EACV,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mDAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,mDAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mDAAW;AACb","sourcesContent":["@value colors: \"client/assets/styles/global-colors.css\";\n@value red from colors;\n@value blue from colors;\n@value green from colors;\n@value black from colors;\n@value grey from colors;\n\n.actionIconsWrapper {\n  font-size: 12px;\n  text-align: right;\n}\n\n.iconBlockWrapper {\n  display: inline-block;\n  text-align: center;\n  padding: 0;\n}\n\n.iconBlock {\n  display: inline-block;\n  padding-right: 10px;\n  padding-top: 15px;\n  padding-left: 10px;\n  text-align: center;\n}\n\n.revokeIconWrapper {\n  display: inline-block;\n  padding: 0px;\n  text-align: center;\n  top: -10px;\n}\n\n.revokeIcon {\n  margin-top: 5px;\n  font-size: 20px !important;\n  color: red;\n  position: relative;\n}\n\n.iconLabel {\n  height: 20px;\n  color: black;\n  font-family: Roboto;\n  font-size: 13px;\n  line-height: 20px;\n  text-align: center;\n  vertical-align: top;\n}\n\n.saveIcon {\n  color: green;\n  font-size: 30px !important;\n  cursor: pointer;\n}\n\n.infoIcon {\n  color: grey;\n  font-size: 30px !important;\n  cursor: pointer;\n}\n\n.approveIcon {\n  color: blue;\n  font-size: 30px !important;\n  cursor: pointer;\n}\n\n.restoreIcon {\n  color: blue;\n  font-size: 30px !important;\n  cursor: pointer;\n}\n\n.editIcon {\n  color: orange;\n  font-size: 30px !important;\n  cursor: pointer;\n}\n\n.deleteIcon {\n  color: red;\n  margin-top: 5px;\n  font-size: 20px !important;\n  position: relative;\n  cursor: pointer;\n}\n\n.rejectIcon {\n  color: red;\n  font-size: 30px !important;\n  cursor: pointer;\n}\n\n.mergeIcon {\n  color: black;\n  font-size: 35px !important;\n  cursor: pointer;\n  transform: rotate(90deg);\n}\n\n.downloadAsCSVIcon {\n  color: grey;\n  font-size: 30px !important;\n  cursor: pointer;\n}\n\n.duplicateIcon {\n  font-size: 30px !important;\n  cursor: pointer;\n}\n\n.center {\n  text-align: center;\n}\n\n.disabled {\n  color: grey;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"client/assets/styles/global-colors.css"`,
	"red": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["red"]}`,
	"blue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue"]}`,
	"green": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["green"]}`,
	"black": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["black"]}`,
	"grey": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["grey"]}`,
	"actionIconsWrapper": `client-modules-common-components-Icons-styles-css-___action-icons__actionIconsWrapper___fhsnW`,
	"iconBlockWrapper": `client-modules-common-components-Icons-styles-css-___action-icons__iconBlockWrapper___hm9AR`,
	"iconBlock": `client-modules-common-components-Icons-styles-css-___action-icons__iconBlock___nB5OC`,
	"revokeIconWrapper": `client-modules-common-components-Icons-styles-css-___action-icons__revokeIconWrapper___voWP_`,
	"revokeIcon": `client-modules-common-components-Icons-styles-css-___action-icons__revokeIcon___W1fIN`,
	"iconLabel": `client-modules-common-components-Icons-styles-css-___action-icons__iconLabel___cgbzl`,
	"saveIcon": `client-modules-common-components-Icons-styles-css-___action-icons__saveIcon___VlsjC`,
	"infoIcon": `client-modules-common-components-Icons-styles-css-___action-icons__infoIcon___fkDzf`,
	"approveIcon": `client-modules-common-components-Icons-styles-css-___action-icons__approveIcon___WzMrZ`,
	"restoreIcon": `client-modules-common-components-Icons-styles-css-___action-icons__restoreIcon___R7NTM`,
	"editIcon": `client-modules-common-components-Icons-styles-css-___action-icons__editIcon___CTZXC`,
	"deleteIcon": `client-modules-common-components-Icons-styles-css-___action-icons__deleteIcon___ox9RD`,
	"rejectIcon": `client-modules-common-components-Icons-styles-css-___action-icons__rejectIcon___wSXpi`,
	"mergeIcon": `client-modules-common-components-Icons-styles-css-___action-icons__mergeIcon___l6vV7`,
	"downloadAsCSVIcon": `client-modules-common-components-Icons-styles-css-___action-icons__downloadAsCSVIcon___Y6BQd`,
	"duplicateIcon": `client-modules-common-components-Icons-styles-css-___action-icons__duplicateIcon___u2r3U`,
	"center": `client-modules-common-components-Icons-styles-css-___action-icons__center___uYtoF`,
	"disabled": `client-modules-common-components-Icons-styles-css-___action-icons__disabled___lwM3t`
};
export default ___CSS_LOADER_EXPORT___;
